var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPanelArrow = function SvgIconPanelArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.817 12.782a.783.783 0 0 0-.015-1.023.604.604 0 0 0-.92.018l-6.7 7.724a.784.784 0 0 0 0 1.006l6.7 7.717c.25.287.662.295.92.017a.783.783 0 0 0 .015-1.023l-6.263-7.215 6.264-7.22Z",
    fill: "#000"
  })));
};
export { SvgIconPanelArrow as ReactComponent };